import { __exports as couponCallout } from './_virtual-couponCallout2.js';
import { __require as requireEs_string_replace } from './node_modules-core-js-modules-es.string.replace.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireVatHelper } from './vp-js-token-engine-build-common-vatHelper.js';
import { __require as requireLocalizations } from './vp-js-token-engine-build-infrastructure-localizations.js';

var hasRequiredCouponCallout;

function requireCouponCallout () {
	if (hasRequiredCouponCallout) return couponCallout;
	hasRequiredCouponCallout = 1;

	Object.defineProperty(couponCallout, "__esModule", {
	  value: true
	});
	couponCallout.filter = filter;
	couponCallout.name = void 0;
	requireEs_string_replace();
	var _container = requireContainer();
	var _vatHelper = requireVatHelper();
	var _localizations = requireLocalizations();
	const name = couponCallout.name = 'couponCallout';
	const DISCOUNT_PRICE_TEMPLATE = "<span class='swan-discount-price'>{{discountPrice}}</span>";
	const COUPON_CODE_TEMPLATE = "<span class='swan-promo-code'>{{couponCode}}</span>";
	const JUST_MESSAGE_TEMPLATE = "<span class='swan-discount-price'>{{justMessageText}}</span>";
	async function filter(couponCode, price, currency, minimumFractionDigits, isVatInc, hideVatMessage, hideShippingMessageInVatMessage) {
	  const scope = this;
	  const culture = _container.contextService.getCulture(scope);
	  const discountPrice = _container.formatterService.formatPrice({
	    currency,
	    minimumFractionDigits,
	    culture,
	    price
	  });
	  const htmlTemplates = {
	    couponCode: COUPON_CODE_TEMPLATE,
	    discountPrice: DISCOUNT_PRICE_TEMPLATE,
	    justMessage: JUST_MESSAGE_TEMPLATE
	  };
	  const template = (0, _localizations.localized)(name, culture);
	  const mustacheVariables = {
	    discountPrice,
	    couponCode
	  };
	  mustacheVariables['justMessageText'] = (0, _localizations.localized)("".concat(name, ".subtemplate"), culture);
	  if (!hideVatMessage) {
	    mustacheVariables['vatMessage'] = await (0, _vatHelper.getVatHtml)(isVatInc, culture, hideShippingMessageInVatMessage, scope);
	  }
	  return _container.mustacheService.replace(template, mustacheVariables, htmlTemplates);
	}
	
	return couponCallout;
}

export { requireCouponCallout as __require };
//# sourceMappingURL=vp-js-token-engine-build-filters-couponCallout.js.map
